'use client'

import { ButtonLink } from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import { Icon, Row, Typography } from '@repo/ui/components'

export const WithdrawOnlinePaymentCTA = ({
  origin,
}: {
  origin: 'layout' | 'container'
}) => {
  const { t } = useTranslate()
  return (
    <Row
      className={`${origin === 'layout' ? 'sticky top-0' : ''} bg-neutral-surface-light p-xs md:p-0 gap-xs justify-between`}
    >
      <Row className='w-fit'>
        {origin === 'layout' && (
          <ButtonLink
            variant='transparent'
            size='md'
            color='neutral'
            href='/wallet/withdraw/online-payment'
            aria-label='Back to Withdraw'
            endIcon={<Icon name='ArrowRightLine' size='md' />}
          />
        )}
        <Typography size='md' weight='bold'>
          {t('walletWithdrawOnlinePaymentPage_title')}
        </Typography>
      </Row>
    </Row>
  )
}
